export class FormControl {
  static get props() {
    return {
      label: String,
      name: String,
      disabled: Boolean,
      readonly: Boolean,
      icon: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      suppressErrorMessages: {
        type: Boolean,
        default: false,
        required: false
      },
      helpText: {
        type: String,
        required: false,
        default: null
      }
    }
  }
}
